import { useEffect, useState } from "react";
import { CompletelyReplacedDDL } from "../../../../CommonDDL/CompletelyReplacedDDL";
import { CommanPlantionDetailsDDLAPI } from "../../../../../Helper/Redux/DDLSlice/DDLSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { StatusOfIntercropsPostAPI, StatusOfIntercropsTableDataAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice";
import OtherInsertSection from "../OtherInsertSection";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";

const StatusofintercropsPopup = (props) => {

    const { handleAddIntercrops, Title, StatusOfIntercropsId, IsPost, T_BeneficiaryPlantationDetailsID, M_BeneficiaryDetailsID, InterCropsDataIsPost, setInterCropsDataIsPost,Flag,data } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [CropName, setCropName] = useState([])
    const [RawData, setRawData] = useState([])
    const [IsOthersData, setIsOthersData] = useState(false)

    const [CompletelyReplacedId, setCompletelyReplacedId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // useEffect(() => {
    //     const data = {
    //         UserID: UserID,
    //         token: token,
    //         Flag: 'CropName',
    //         M_TableUserMasterID: UserID,
    //         setCropName: setCropName,
    //     }
    //     dispatch(CommanPlantionDetailsDDLAPI({ data }))
    // }, [IsOthersData])

    useEffect(() => {
        const data = {

            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            ReplaceCrop_M_IndicatorMasterID: CompletelyReplacedId.ID,
            M_TableUserMasterID: UserID,
            Flag: "StatusInterCrops",
            token: token,
            setStatusInterCropsData: setCropName,
            handleSetData: handleSetData,
        }
        dispatch(StatusOfIntercropsTableDataAPI({ data }))

    }, [IsOthersData,InterCropsDataIsPost,CompletelyReplacedId.ID])

    const { isFirstPartLoading } = useSelector(state => state.StatusOfIntercropsTableData)

    // const { DDLData } = useSelector(state => state.CommanPlantionDetailsDDLData)
    const handleValueChange = (newValue) => {
        if (RawData?.includes(newValue)) {
            setRawData(RawData.filter(value => value != newValue));
        } else {
            setRawData([...RawData, newValue]);
        }

    };
    // console.log("RawData", RawData?.includes(16))


    var allCheckData = ""

    const handleSetData = (Data) => {
        let roleData = Data?.map((item) => ({ ...item, isChecked: item.isCheck == 1 ? true : false, }))

        setRawData(roleData)
        roleData && roleData.forEach((item) => {
            if (item.isChecked) {
                allCheckData = allCheckData + item.statusInterCropsID + ","
            }
        })
        setCropName(allCheckData)
        // console.log('allCheckData', allCheckData)
    }


    const handleCheckValueChange = (check, index) => {
        if (RawData) {
            let tempGridData = [...RawData]
            tempGridData[index].isChecked = !(tempGridData[index].isChecked)
            setRawData(tempGridData)
        }

        let allCheckData = ""
        RawData.forEach((item) => {
            if (item.isChecked) {
                allCheckData = allCheckData + item.statusInterCropsID + ","
            }

            setCropName(allCheckData)
        })

    }

    const handleInterCropsDataIsPost = () => {
        setInterCropsDataIsPost(!InterCropsDataIsPost)
        handleAddIntercrops()
    }

    const handleSubmit = () => {
        const data = {
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            ReplaceCrop_M_IndicatorMasterID: CompletelyReplacedId.ID,
            RawData: CropName,
            M_TableUserMasterID: UserID,
            token: token,
            handleInterCropsDataIsPost

        }
        // console.log("RawData",RawData)
        dispatch(StatusOfIntercropsPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.StatusOfIntercropsPostData)

    return (<>
        <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
        {isFirstPartLoading && <Loading />}
            <div className="modal-dialog modal-xl" role="document"  >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title ml-lg-5" id="exampleModalLongTitle">{Title}</h5>
                        <button onClick={handleAddIntercrops} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body mx-4">

                        {
                            StatusOfIntercropsId.ID == 83 ?
                                <div className="row">
                                    <div className="col-12 col-lg-5 mx-auto">
                                        <CompletelyReplacedDDL
                                            CompletelyReplacedId={CompletelyReplacedId}
                                            setCompletelyReplacedId={setCompletelyReplacedId}
                                            apiFlag='CompletelyReplaced'
                                            Flag='Insert'
                                            data=''
                                            IsPost={IsPost}
                                        />
                                    </div>
                                </div>
                                :
                                ''
                        }

                        <div className="row">

                            {
                                RawData  && RawData.length > 0 && RawData.map((i, j) =>
                                    <>
                                        <div className="col-12 col-lg-3 pt-2 pb-2 ">
                                            <form >
                                                <input type="checkbox"
                                                    className="px-3"
                                                    id={i.statusInterCropsID}
                                                    name={i.statusInterCropsID}
                                                    checked={i.isChecked}
                                                    value={i.statusInterCropsID}
                                                    // onChange={() => handleValueChange(i.statusInterCropsID)}
                                                    onChange={() => handleCheckValueChange(1, j)} />
                                                    
                                                <span for="Weather" className="ps-2">{i.statusInterCrops}</span>
                                            </form>
                                        </div>

                                    </>

                                )}
                            {
                                RawData?.includes(16) &&
                                <OtherInsertSection
                                    Flag='NameOfCrop'
                                    IsOthersData={IsOthersData}
                                    setIsOthersData={setIsOthersData}

                                />
                            }



                            <div className="col-12 col-lg-4 mx-auto pt-2 ">
                                <div className="form-group w-80 d-flex justify-content-end">
                                    <button
                                        type='button'
                                        onClick={handleSubmit}
                                        className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                        Add
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleAddIntercrops}
                                        className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                        Close
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default StatusofintercropsPopup;